/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  spacing: {
    0: "0px",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "48px",
    7: "56px",
    8: "64px",
    9: "72px",
    10: "80px",
    11: "88px",
    12: "96px",
    13: "104px",
    14: "112px",
    15: "120px",
    16: "128px",
    17: "136px",
    18: "144px",
    19: "152px",
    20: "160px",
    21: "168px",
    22: "176px",
    23: "184px",
    24: "192px",
    25: "200px",
    "0p5": "4px",
    "0p75": "6px",
    "1p25": "10px",
    "1p5": "12px",
    "0p25": "2px",
    "0p125": "1px",
    "2p5": "20px",
    "3p5": "28px",
    "5p5": "44px",
    "7p5": "60px",
    "6p5": "52px",
    "1p75": "14px",
    factor: "8px",
    "2p25": "18px",
    "0p625": "5px",
    "0p875": "7px",
    "0p375": "3px",
    "1p125": "9px",
    "1p375": "11px",
    "1p625": "13px",
    "1p875": "15px",
    "6p75": "54px",
    "4p5": "36px",
    "8p5": "68px",
    "9p5": "76px",
    "3p75": "30px",
    "7p75": "62px",
    "12p75": "102px",
    "11p75": "94px",
    "2p75": "22px",
    "3p25": "26px",
    "4p25": "34px",
    "4p75": "38px",
    negative: {
      1: "-8px",
      2: "-16px",
      3: "-24px",
      4: "-32px",
      5: "-40px",
      6: "-48px",
      7: "-56px",
      8: "-64px",
      9: "-72px",
      10: "-80px",
      11: "-88px",
      12: "-96px",
      13: "-104px",
      14: "-112px",
      15: "-120px",
      16: "-128px",
      17: "-136px",
      18: "-144px",
      19: "-152px",
      20: "-160px",
      21: "-168px",
      22: "-176px",
      23: "-183px",
      24: "-192px",
      25: "-200px",
      "0p5": "-4px",
      "0p25": "-2px",
      "0p75": "-6px",
      "0p125": "-1px",
      "0p375": "-3px",
      "0p625": "-5px",
      "0p825": "-7px",
      "1p75": "-14px",
      "1p625": "-13px",
      "1p5": "-12px",
      "1p375": "-11px",
      "1p875": "-15px",
      "1p25": "-10px",
      "1p125": "-9px",
      "3p75": "-30px",
      "3p5": "-28px",
      "3p25": "-26px",
      "2p75": "-22px",
      "2p5": "-20px",
      "2p25": "-18px",
      "8p5": "-68px",
      "7p75": "-62px",
      "6p25": "-50px",
      "5p25": "-42px",
      "6p75": "-54px",
      "7p5": "-60px",
      "8p75": "-70px",
      "4p75": "-38px",
      "5p5": "-44px",
      "4p5": "-36px",
      "6p5": "-52px",
      "4p25": "-34px",
      "12p75": "-102px",
      "9p5": "-76px",
      "11p75": "-94px",
      "3p125": "-25px",
      "10p5": "-84px",
    },
    "5p25": "42px",
    "6p25": "50px",
    "3p125": "25px",
    "8p75": "70px",
    "10p5": "84px",
  },
  palette: {
    text: {
      primary: {
        light: "#1f1f23",
        dark: "#eeeef0",
      },
      secondary: {
        light: "#00000a9c",
        dark: "#f3f3ffb8",
      },
      disabled: {
        light: "#00001e45",
        dark: "#e5e3fd63",
      },
      tertiary: {
        light: "#00001273",
        dark: "#e9e7ff70",
      },
      vibrant: {
        primary: {
          light: "#333333",
          dark: "#fffffff5",
        },
        secondary: {
          light: "#999999",
          dark: "#999999",
        },
        tertiary: {
          light: "#bfbfbf",
          dark: "#404040",
        },
        disabled: {
          light: "#d9d9d9",
          dark: "#262626",
        },
        control: {
          primary: {
            light: "#404040",
            dark: "#bfbfbf",
          },
          secondary: {
            light: "#8c8c8c",
            dark: "#737373",
          },
          disabled: {
            light: "#d9d9d9",
            dark: "#262626",
          },
          prominent: {
            light: "#ffffff",
            dark: "#333333",
          },
          glassProminent: {
            light: "#ffffff",
            dark: "#bfbfbf",
          },
        },
      },
    },
    action: {
      hover: {
        light: "#6363690a",
        dark: "#b2b2bb14",
      },
      selected: {
        light: "#63636914",
        dark: "#b2b2bb29",
      },
      disabledBackground: {
        light: "#0010300f",
        dark: "#e4dcf81c",
      },
      focus: {
        light: "#6363691f",
        dark: "#b2b2bb1f",
      },
      disabled: {
        light: "#00001e45",
        dark: "#e5e3fd63",
      },
      active: {
        light: "#00000a9c",
        dark: "#f3f3ffb8",
      },
      activated: {
        light: "#6363691f",
        dark: "#b2b2bb3d",
      },
      hoverOpacity: {
        light: 0.04,
        dark: 0.08,
      },
      selectedOpacity: {
        light: 0.08,
        dark: 0.16,
      },
      disabledOpacity: {
        light: 0.38,
        dark: 0.38,
      },
      focusOpacity: {
        light: 0.12,
        dark: 0.12,
      },
      activatedOpacity: {
        light: 0.12,
        dark: 0.24,
      },
      focusVisible: {
        light: "#6363694d",
        dark: "#b2b2bb4d",
      },
      outlinedBorderOpacity: {
        light: 0.5,
        dark: 0.5,
      },
    },
    error: {
      1: {
        light: "#fffcfc",
        dark: "#100807",
      },
      2: {
        light: "#fff7f6",
        dark: "#1f1110",
      },
      3: {
        light: "#ffebe8",
        dark: "#3d0f0e",
      },
      4: {
        light: "#ffdad5",
        dark: "#54060a",
      },
      5: {
        light: "#ffcbc5",
        dark: "#660d11",
      },
      6: {
        light: "#ffbbb4",
        dark: "#781c1c",
      },
      7: {
        light: "#fba69e",
        dark: "#922d2b",
      },
      8: {
        light: "#f38a82",
        dark: "#bd3c39",
      },
      9: {
        light: "#e3242e",
        dark: "#e3242e",
      },
      10: {
        light: "#d4001d",
        dark: "#be3d3a",
      },
      11: {
        light: "#d70e23",
        dark: "#ff8f86",
      },
      12: {
        light: "#691013",
        dark: "#ffd0cb",
      },
      50: {
        light: "#ffebe8",
        dark: "#ffebe8",
      },
      100: {
        light: "#ffcbc5",
        dark: "#ffcbc5",
      },
      200: {
        light: "#ffbbb4",
        dark: "#ffbbb4",
      },
      300: {
        light: "#fba69e",
        dark: "#fba69e",
      },
      400: {
        light: "#ff8f86",
        dark: "#ff8f86",
      },
      500: {
        light: "#e3242e",
        dark: "#e3242e",
      },
      600: {
        light: "#d4001d",
        dark: "#d4001d",
      },
      700: {
        light: "#d70e23",
        dark: "#d70e23",
      },
      800: {
        light: "#660d11",
        dark: "#660d11",
      },
      900: {
        light: "#54060a",
        dark: "#54060a",
      },
      950: {
        light: "#3d0f0e",
        dark: "#3d0f0e",
      },
      lightest: {
        light: "#ffdad5",
        dark: "#ffdad5",
      },
      light: {
        light: "#ff8f86",
        dark: "#ff8f86",
      },
      main: {
        light: "#e3242e",
        dark: "#e3242e",
      },
      dark: {
        light: "#d70e23",
        dark: "#d70e23",
      },
      darkest: {
        light: "#781c1c",
        dark: "#781c1c",
      },
      contrast: {
        light: "#ffffff",
        dark: "#ffffff",
      },
      borderRegular: {
        light: "#f5160061",
        dark: "#fe49448f",
      },
      a2: {
        light: "#ff1d000a",
        dark: "#fd584317",
      },
      a1: {
        light: "#ff000003",
        dark: "#e9000008",
      },
      a11: {
        light: "#d50016f2",
        dark: "#ff8f86",
      },
      a8: {
        light: "#e711007d",
        dark: "#ff4e4aba",
      },
      a12: {
        light: "#5f0003f0",
        dark: "#ffd0cb",
      },
      a9: {
        light: "#de000cdb",
        dark: "#ff2833e3",
      },
      a5: {
        light: "#ff1b003b",
        dark: "#fd121b61",
      },
      a4: {
        light: "#ff1f0029",
        dark: "#ff00084f",
      },
      a3: {
        light: "#ff220017",
        dark: "#ff221936",
      },
      a7: {
        light: "#f5160061",
        dark: "#fe49448f",
      },
      a6: {
        light: "#ff18014a",
        dark: "#fd323173",
      },
      a10: {
        light: "#d4001d",
        dark: "#ff4f4bbd",
      },
      indicator: {
        light: "#e3242e",
        dark: "#e3242e",
      },
      track: {
        light: "#e3242e",
        dark: "#e3242e",
      },
      surface: {
        light: "#fff5f4cc",
        dark: "#35181580",
      },
      solidHover: {
        light: "#d4001d",
        dark: "#be3d3a",
      },
      backgroundSoft: {
        light: "#ff220017",
        dark: "#ff221936",
      },
      highContrast: {
        light: "#5f0003f0",
        dark: "#ffd0cb",
      },
      text: {
        light: "#d50016f2",
        dark: "#ff8f86",
      },
      borderSubtle: {
        light: "#ff18014a",
        dark: "#fd323173",
      },
      solid: {
        light: "#e3242e",
        dark: "#e3242e",
      },
      backgroundSubtle: {
        light: "#ff1d000a",
        dark: "#fd584317",
      },
      backgroundSubtlest: {
        light: "#ff000003",
        dark: "#e9000008",
      },
      backgroundSoftHover: {
        light: "#ff1f0029",
        dark: "#ff00084f",
      },
      backgroundSoftActive: {
        light: "#ff1b003b",
        dark: "#fd121b61",
      },
      borderStrong: {
        light: "#e711007d",
        dark: "#ff4e4aba",
      },
      onHighContrast: {
        light: "#ffd0cb",
        dark: "#691013",
      },
    },
    warning: {
      1: {
        light: "#fefcfb",
        dark: "#0e0906",
      },
      2: {
        light: "#fff6f0",
        dark: "#1d140f",
      },
      3: {
        light: "#ffecdd",
        dark: "#321d0f",
      },
      4: {
        light: "#ffd9b7",
        dark: "#462001",
      },
      5: {
        light: "#ffcba0",
        dark: "#542906",
      },
      6: {
        light: "#ffbf92",
        dark: "#633716",
      },
      7: {
        light: "#f3ae80",
        dark: "#7a4824",
      },
      8: {
        light: "#e69761",
        dark: "#9d5d2e",
      },
      9: {
        light: "#e87700",
        dark: "#e87700",
      },
      10: {
        light: "#dc6a00",
        dark: "#dc6a00",
      },
      11: {
        light: "#c65b00",
        dark: "#ffa25b",
      },
      12: {
        light: "#533119",
        dark: "#ffdfc9",
      },
      50: {
        light: "#ffecdd",
        dark: "#ffecdd",
      },
      100: {
        light: "#ffcba0",
        dark: "#ffcba0",
      },
      200: {
        light: "#ffbf92",
        dark: "#ffbf92",
      },
      300: {
        light: "#f3ae80",
        dark: "#f3ae80",
      },
      400: {
        light: "#ffa25b",
        dark: "#ffa25b",
      },
      500: {
        light: "#e87700",
        dark: "#e87700",
      },
      600: {
        light: "#dc6a00",
        dark: "#dc6a00",
      },
      700: {
        light: "#c65b00",
        dark: "#c65b00",
      },
      800: {
        light: "#633716",
        dark: "#633716",
      },
      900: {
        light: "#462001",
        dark: "#462001",
      },
      950: {
        light: "#321d0f",
        dark: "#321d0f",
      },
      lightest: {
        light: "#ffd9b7",
        dark: "#ffd9b7",
      },
      light: {
        light: "#ffa25b",
        dark: "#ffa25b",
      },
      main: {
        light: "#e87700",
        dark: "#e87700",
      },
      dark: {
        light: "#c65b00",
        dark: "#c65b00",
      },
      darkest: {
        light: "#633716",
        dark: "#633716",
      },
      contrast: {
        light: "#ffffff",
        dark: "#ffffff",
      },
      borderRegular: {
        light: "#e75d0080",
        dark: "#fd904175",
      },
      a12: {
        light: "#401b00e6",
        dark: "#ffdfc9",
      },
      a11: {
        light: "#c65b00",
        dark: "#ffa25b",
      },
      a10: {
        light: "#dc6a00",
        dark: "#ff7c00d9",
      },
      a1: {
        light: "#c0400005",
        dark: "#de000005",
      },
      a8: {
        light: "#d757009e",
        dark: "#fe944599",
      },
      a6: {
        light: "#ff6a006e",
        dark: "#fd85295e",
      },
      a5: {
        light: "#ff74005e",
        dark: "#ff70004f",
      },
      a4: {
        light: "#ff790047",
        dark: "#fd620040",
      },
      a3: {
        light: "#ff710021",
        dark: "#fd7b232b",
      },
      a2: {
        light: "#ff66000f",
        dark: "#fc843c14",
      },
      a9: {
        light: "#e87700",
        dark: "#fe8200e8",
      },
      a7: {
        light: "#e75d0080",
        dark: "#fd904175",
      },
      indicator: {
        light: "#e87700",
        dark: "#e87700",
      },
      track: {
        light: "#e87700",
        dark: "#e87700",
      },
      surface: {
        light: "#fff4eccc",
        dark: "#311e1380",
      },
      backgroundSubtle: {
        light: "#ff66000f",
        dark: "#fc843c14",
      },
      highContrast: {
        light: "#401b00e6",
        dark: "#ffdfc9",
      },
      solidHover: {
        light: "#dc6a00",
        dark: "#db6b00",
      },
      solid: {
        light: "#e87700",
        dark: "#e87700",
      },
      backgroundSoft: {
        light: "#ff710021",
        dark: "#fd7b232b",
      },
      text: {
        light: "#c65b00",
        dark: "#ffa25b",
      },
      borderSubtle: {
        light: "#ff6a006e",
        dark: "#fd85295e",
      },
      backgroundSubtlest: {
        light: "#c0400005",
        dark: "#de000005",
      },
      backgroundSoftHover: {
        light: "#ff790047",
        dark: "#fd620040",
      },
      backgroundSoftActive: {
        light: "#ff74005e",
        dark: "#ff70004f",
      },
      borderStrong: {
        light: "#d757009e",
        dark: "#fe944599",
      },
      onHighContrast: {
        light: "#ffdfc9",
        dark: "#533119",
      },
    },
    success: {
      1: {
        light: "#fafffc",
        dark: "#050c08",
      },
      2: {
        light: "#f2fcf7",
        dark: "#101a15",
      },
      3: {
        light: "#e1f8ec",
        dark: "#112c20",
      },
      4: {
        light: "#cef4e0",
        dark: "#0b3b29",
      },
      5: {
        light: "#b7edd2",
        dark: "#0f4a33",
      },
      6: {
        light: "#9ae3c0",
        dark: "#15593f",
      },
      7: {
        light: "#71d4a8",
        dark: "#1a6a4b",
      },
      8: {
        light: "#00c086",
        dark: "#1b7d59",
      },
      9: {
        light: "#05c288",
        dark: "#05c288",
      },
      10: {
        light: "#00b67d",
        dark: "#00b67d",
      },
      11: {
        light: "#008353",
        dark: "#35d59a",
      },
      12: {
        light: "#093e2a",
        dark: "#a9f3cf",
      },
      50: {
        light: "#e1f8ec",
        dark: "#e1f8ec",
      },
      100: {
        light: "#b7edd2",
        dark: "#b7edd2",
      },
      200: {
        light: "#9ae3c0",
        dark: "#9ae3c0",
      },
      300: {
        light: "#71d4a8",
        dark: "#71d4a8",
      },
      400: {
        light: "#35d59a",
        dark: "#35d59a",
      },
      500: {
        light: "#05c288",
        dark: "#05c288",
      },
      600: {
        light: "#008353",
        dark: "#008353",
      },
      700: {
        light: "#15593f",
        dark: "#15593f",
      },
      800: {
        light: "#0f4a33",
        dark: "#0f4a33",
      },
      900: {
        light: "#0b3b29",
        dark: "#0b3b29",
      },
      950: {
        light: "#112c20",
        dark: "#112c20",
      },
      lightest: {
        light: "#cef4e0",
        dark: "#cef4e0",
      },
      light: {
        light: "#35d59a",
        dark: "#35d59a",
      },
      main: {
        light: "#05c288",
        dark: "#05c288",
      },
      dark: {
        light: "#008353",
        dark: "#008353",
      },
      darkest: {
        light: "#15593f",
        dark: "#15593f",
      },
      contrast: {
        light: "#ffffff",
        dark: "#ffffff",
      },
      borderRegular: {
        light: "#00b2638f",
        dark: "#35ffae63",
      },
      a11: {
        light: "#008353",
        dark: "#3dfeb7d4",
      },
      a1: {
        light: "#00ff6605",
        dark: "#00b40003",
      },
      a9: {
        light: "#00c186fa",
        dark: "#04ffb1bf",
      },
      a12: {
        light: "#003722f5",
        dark: "#b1ffd8f2",
      },
      a8: {
        light: "#00c086",
        dark: "#2fffb178",
      },
      a5: {
        light: "#00c06047",
        dark: "#20fea442",
      },
      a4: {
        light: "#00c65e30",
        dark: "#13ffa133",
      },
      a2: {
        light: "#00c5630d",
        dark: "#72faa112",
      },
      a7: {
        light: "#00b2638f",
        dark: "#35ffae63",
      },
      a6: {
        light: "#00b96066",
        dark: "#2efdab54",
      },
      a10: {
        light: "#00b67d",
        dark: "#00feadb5",
      },
      a3: {
        light: "#00c45e1f",
        dark: "#42fba024",
      },
      indicator: {
        light: "#05c288",
        dark: "#05c288",
      },
      track: {
        light: "#05c288",
        dark: "#05c288",
      },
      surface: {
        light: "#effbf5cc",
        dark: "#172a1f80",
      },
      highContrast: {
        light: "#003722f5",
        dark: "#b1ffd8f2",
      },
      text: {
        light: "#008353",
        dark: "#3dfeb7d4",
      },
      solid: {
        light: "#05c288",
        dark: "#05c288",
      },
      backgroundSubtle: {
        light: "#00c5630d",
        dark: "#72faa112",
      },
      backgroundSoft: {
        light: "#00c45e1f",
        dark: "#42fba024",
      },
      solidHover: {
        light: "#00b67d",
        dark: "#00b67d",
      },
      borderSubtle: {
        light: "#00b96066",
        dark: "#2efdab54",
      },
      backgroundSubtlest: {
        light: "#00ff6605",
        dark: "#00b40003",
      },
      backgroundSoftHover: {
        light: "#00c65e30",
        dark: "#13ffa133",
      },
      backgroundSoftActive: {
        light: "#00c06047",
        dark: "#20fea442",
      },
      borderStrong: {
        light: "#00c086",
        dark: "#2fffb178",
      },
      onHighContrast: {
        light: "#a9f3cf",
        dark: "#093e2a",
      },
    },
    background: {
      primary: {
        light: "#ffffff",
        dark: "#090a0b",
      },
      level1: {
        light: "#f9f9fb",
        dark: "#17171a",
      },
      level2: {
        light: "#f0f0f2",
        dark: "#212125",
      },
      level3: {
        light: "#e8e8eb",
        dark: "#29292d",
      },
      grouped: {
        primary: {
          light: "#f9f9fb",
          dark: "#17171a",
        },
        secondary: {
          light: "#ffffff",
          dark: {
            light: "#f9f9fb",
            dark: "#17171a",
          },
        },
        tertiary: {
          light: "#f9f9fb",
          dark: "#17171a",
        },
        elevated: {
          primary: {
            light: "#f9f9fb",
            dark: "#17171a",
          },
          secondary: {
            light: "#ffffff",
            dark: {
              light: "#e8e8eb",
              dark: "#29292d",
            },
          },
          tertiary: {
            light: "#f9f9fb",
            dark: "#17171a",
          },
        },
      },
      paper: {
        light: "#ffffff",
        dark: "#090a0b",
      },
      secondary: {
        light: "#f9f9fb",
        dark: "#17171a",
      },
      tertiary: {
        light: "#ffffff",
        dark: {
          light: "#f0f0f2",
          dark: "#212125",
        },
      },
      elevated: {
        primary: {
          light: "#ffffff",
          dark: {
            light: "#f0f0f2",
            dark: "#212125",
          },
        },
        secondary: {
          light: "#f9f9fb",
          dark: "#17171a",
        },
        tertiary: {
          light: "#ffffff",
          dark: {
            light: "#e1e1e5",
            dark: "#303035",
          },
        },
      },
    },
    white: {
      light: "#ffffff",
      dark: "#ffffff",
    },
    black: {
      light: "#000000",
      dark: "#000000",
    },
    overlay: {
      lightToDark: {
        light: "#f6f6f67a",
        dark: "#0000007a",
      },
      default: {
        light: "#00000033",
        dark: "#0000007a",
      },
      elevation: {
        1: {
          light: "#ffffff0d",
          dark: "#ffffff0d",
        },
        2: {
          light: "#ffffff12",
          dark: "#ffffff12",
        },
        3: {
          light: "#ffffff14",
          dark: "#ffffff14",
        },
        4: {
          light: "#ffffff17",
          dark: "#ffffff17",
        },
        5: {
          light: "#ffffff1a",
          dark: "#ffffff1a",
        },
        6: {
          light: "#ffffff1c",
          dark: "#ffffff1c",
        },
        7: {
          light: "#ffffff1c",
          dark: "#ffffff1c",
        },
        8: {
          light: "#ffffff1f",
          dark: "#ffffff1f",
        },
        9: {
          light: "#ffffff1f",
          dark: "#ffffff1f",
        },
        10: {
          light: "#ffffff21",
          dark: "#ffffff21",
        },
        11: {
          light: "#ffffff21",
          dark: "#ffffff21",
        },
        12: {
          light: "#ffffff24",
          dark: "#ffffff24",
        },
        13: {
          light: "#ffffff24",
          dark: "#ffffff24",
        },
        14: {
          light: "#ffffff24",
          dark: "#ffffff24",
        },
        15: {
          light: "#ffffff24",
          dark: "#ffffff24",
        },
        16: {
          light: "#ffffff26",
          dark: "#ffffff26",
        },
        17: {
          light: "#ffffff26",
          dark: "#ffffff26",
        },
        18: {
          light: "#ffffff26",
          dark: "#ffffff26",
        },
        19: {
          light: "#ffffff29",
          dark: "#ffffff29",
        },
        20: {
          light: "#ffffff29",
          dark: "#ffffff29",
        },
        21: {
          light: "#ffffff29",
          dark: "#ffffff29",
        },
        22: {
          light: "#ffffff29",
          dark: "#ffffff29",
        },
        23: {
          light: "#ffffff29",
          dark: "#ffffff29",
        },
        24: {
          light: "#ffffff2b",
          dark: "#ffffff2b",
        },
      },
    },
    chart: {
      chartDatasetPositive: {
        light: "#00c086",
        dark: "#1b7d59",
      },
      datasetNegative: {
        light: "#f38a82",
        dark: "#bd3c39",
      },
      datasetNeutral: {
        light: "#bbbbc3",
        dark: "#5f5f6a",
      },
      datasetWarning: {
        light: "#e69761",
        dark: "#9d5d2e",
      },
    },
    divider: {
      regular: {
        light: "#0010300f",
        dark: "#e4dcf81c",
      },
      opaque: {
        light: "#f0f0f2",
        dark: "#212125",
      },
      vibrant: {
        light: "#e6e6e6",
        dark: "#1a1a1a",
      },
    },
    card: {
      border: {
        light: "#0010300f",
        dark: "#e4dcf81c",
      },
      outlinedBorder: {
        light: "#0010300f",
        dark: "#e4dcf81c",
      },
    },
    mode: {
      light: "Light",
      dark: "Dark",
    },
    fill: {
      secondary: {
        light: "#00002217",
        dark: "#ece6fc24",
      },
      quaternary: {
        light: "#0000220f",
        dark: "#e9dafb0f",
      },
      tertiary: {
        light: "#0010300f",
        dark: "#e4dcf81c",
      },
      primary: {
        light: "#0000221f",
        dark: "#ece7ff2b",
      },
      vibrant: {
        primary: {
          light: "#cccccc",
          dark: "#333333",
        },
        secondary: {
          light: "#e0e0e0",
          dark: "#1f1f1f",
        },
        tertiary: {
          light: "#ededed",
          dark: "#121212",
        },
        quaternary: {
          light: "#f3f3f3",
          dark: "#0c0c0c",
        },
        prominent: {
          light: "#1e2022",
          dark: "#e0e0e0",
        },
      },
    },
    segmentedControl: {
      selectionBackground: {
        light: "#ffffff",
        dark: "#090a0b",
      },
    },
    track: {
      light: "#00002217",
      dark: "#ece6fc24",
    },
    thumb: {
      light: "#ffffff",
      dark: "#ffffff",
    },
    surface: {
      light: "#ffffffd9",
      dark: "#00000040",
    },
    avatar: {
      background: {
        light: "#0010300f",
        dark: "#e4dcf81c",
      },
    },
    transparent: {
      light: "#ffffff00",
      dark: "#00000000",
    },
    checkbox: {
      border: {
        light: "#00002030",
        dark: "#e5e2fc47",
      },
    },
    helloBar: {
      background: {
        light: "#000005e0",
        dark: "#fcfcfef0",
      },
      text: {
        light: "#eeeef0",
        dark: "#1f1f23",
      },
    },
    lightToDark: {
      light: "#ffffff",
      dark: "#1f1f23",
    },
    shadow: {
      1: {
        light: "#0000000a",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      2: {
        light: "#0000000f",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      3: {
        light: "#0000000f",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      4: {
        light: "#00000012",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      5: {
        light: "#00000014",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      6: {
        light: "#00000017",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      7: {
        light: "#00000017",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      8: {
        light: "#0000001a",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      9: {
        light: "#0000001c",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      10: {
        light: "#0000001f",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      11: {
        light: "#0000001f",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      12: {
        light: "#00000021",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      13: {
        light: "#00000024",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      14: {
        light: "#00000026",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      15: {
        light: "#00000026",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      16: {
        light: "#00000029",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      17: {
        light: "#0000002b",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      18: {
        light: "#0000002e",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      19: {
        light: "#0000002e",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      20: {
        light: "#00000030",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      21: {
        light: "#00000033",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      22: {
        light: "#00000036",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      23: {
        light: "#00000036",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
      24: {
        light: "#00000038",
        dark: {
          light: "#ffffff00",
          dark: "#00000000",
        },
      },
    },
    whiteToBlack: {
      light: "#ffffff",
      dark: "#000000",
    },
    blackToWhite: {
      light: "#000000",
      dark: "#ffffff",
    },
    material: {
      ultrathin: {
        light: "#f6f6f65c",
        dark: "#12121266",
      },
      thin: {
        light: "#f6f6f67a",
        dark: "#12121280",
      },
      regular: {
        light: "#f6f6f699",
        dark: "#12121299",
      },
      thick: {
        light: "#f6f6f6c2",
        dark: "#121212b3",
      },
      ultrathick: {
        light: "#f6f6f6d6",
        dark: "#121212cc",
      },
      accessory: {
        light: "#e1e1e180",
        dark: "#33333380",
      },
    },
    filter: {
      chip: {
        vibrant: {
          active: {
            shadow: {
              light: "#ffffff1f",
              dark: "#0000001f",
            },
          },
        },
      },
    },
  },
  base: {
    button: {
      medium: {
        size: "40px",
        radiusRounded: "9999px",
        paddingHorizontal: "16px",
        paddingVertical: "6px",
        spaceBetween: "6px",
        labelPadding: "0px",
      },
      xsmall: {
        size: "28px",
        radiusRounded: "9999px",
        paddingHorizontal: "10px",
        paddingVertical: "2px",
        labelPadding: "0px",
        spaceBetween: "4px",
      },
      small: {
        size: "32px",
        radiusRounded: "9999px",
        paddingHorizontal: "12px",
        paddingVertical: "4px",
        labelPadding: "0px",
        spaceBetween: "4px",
      },
      large: {
        size: "48px",
        radiusRounded: "9999px",
        paddingHorizontal: "22px",
        paddingVertical: "8px",
        labelPadding: "0px",
        spaceBetween: "8px",
      },
    },
    list: {
      item: {
        rounded: {
          radius: "20px",
        },
        minHeight: "48px",
        paddingHorizontal: "16px",
        leadingMinWidth: "24px",
        spaceBetween: "16px",
        paddingVertical: "12px",
        trailingMinWidth: "20px",
      },
      radiusRounded: "26px",
    },
    divider: {
      middleMargin: "16px",
      inset: "20px",
    },
    thumbnail: {
      sizeLarge: "60px",
      sizeMedium: "40px",
      sizeSmall: "32px",
      size2xs: "24px",
      sizeXlarge: "80px",
      sizeXsmall: "28px",
      radiusXsmall: "9.33px",
      radiusSmall: "10.67px",
      radiusMedium: "13.33px",
      radiusLarge: "20px",
      radiusXlarge: "26.67px",
      radius2xs: "8px",
      size2xl: "120px",
      radius2xl: "40px",
      radius: "33.33%",
      size3xs: "18px",
      radius3xs: "6px",
    },
    chip: {
      medium: {
        size: "32px",
        labelPadding: "9px",
        leadingPaddingLeft: "4px",
        labelTextPadding: "2px",
        labelSpaceBetween: "4px",
        leadingMarginRight: "-4px",
      },
      small: {
        size: "24px",
        leadingPaddingLeft: "3px",
        labelPadding: "5px",
        labelSpaceBetween: "1px",
        labelTextPadding: "3px",
        leadingMarginRight: "-4px",
      },
      large: {
        size: "40px",
        labelPadding: "14px",
        leadingPadding: "8px",
        labelSpaceBetween: "6px",
        labelTextPadding: "2px",
        leadingMarginRight: "-4px",
      },
      radius: "9999px",
    },
    tooltip: {
      radius: "12px",
    },
    toast: {
      radius: "20px",
      minHeight: "48px",
      minWidth: "200px",
      maxWidth: "400px",
    },
    alert: {
      radius: "20px",
    },
    field: {
      radius: "12px",
      medium: {
        height: "40px",
        paddingVertical: "9px",
      },
      small: {
        height: "32px",
        paddingVertical: "6px",
      },
      leadingMinWidth: "24px",
      spaceBetween: "12px",
      trailingMinWidth: "24px",
      paddingHorizontal: "12px",
    },
    accordion: {
      radiusRounded: "16px",
      summary: {
        minHeight: "48px",
        paddingHorizontal: "16px",
        paddingVertical: "12px",
        spaceBetween: "16px",
        leadingMinWidth: "24px",
      },
      gapRounded: "8px",
      details: {
        paddingTop: "8px",
        paddingBottom: "16px",
        paddingHorizontal: "16px",
      },
    },
    container: {
      widthXs: "400px",
      widthSm: "600px",
      widthMd: "900px",
      widthLg: "1200px",
      widthXl: "1400px",
      widthMax: "1680px",
    },
    page: {
      container: {
        paddingLg: "40px",
        paddingMd: "32px",
        paddingSm: "24px",
        paddingXs: "16px",
        paddingXl: "72px",
        paddingMax: "72px",
        gapXs: "16px",
        gapSm: "24px",
        gapMd: "24px",
        gapLg: "24px",
        gapXl: "32px",
        gapMax: "32px",
      },
      main: {
        paddingTopXs: "0px",
        paddingTopSm: "0px",
        paddingTopMd: "0px",
        paddingTopLg: "0px",
        paddingTopXl: "0px",
        paddingTopMax: "0px",
        paddingBottomXs: "16px",
        paddingBottomSm: "40px",
        paddingBottomMd: "40px",
        paddingBottomLg: "80px",
        paddingBottomXl: "80px",
        paddingBottomMax: "80px",
      },
      header: {
        paddingBottomXs: "0px",
        paddingTopMax: "20px",
        paddingTopXl: "20px",
        paddingTopLg: "20px",
        paddingTopMd: "20px",
        paddingTopSm: "20px",
        paddingTopXs: "0px",
        paddingBottomSm: "0px",
        paddingBottomMd: "0px",
        paddingBottomLg: "0px",
        paddingBottomXl: "0px",
        paddingBottomMax: "0px",
      },
    },
    menu: {
      list: {
        padding: "10px",
        gap: "4px",
      },
      item: {
        minHeight: "40px",
        paddingVertical: "8px",
        radius: "20px",
        leadingMinWidth: "24px",
        spaceBetween: "12px",
        paddingHorizontal: "12px",
        trailingMinWidth: "24px",
      },
      dropdown: {
        contentPadding: "24px",
      },
    },
    card: {
      radius: "26px",
      contentPadding: "24px",
    },
    tabs: {
      minHeight: "40px",
      nestedIndent: "12px",
    },
    slider: {
      height: "44px",
      heightSmall: "36px",
    },
    toolbar: {
      gap: "16px",
      buttonGroup: {
        gap: "8px",
        padding: "4px",
      },
      minHeight: "40px",
    },
    helloBar: {
      minHeight: "48px",
      contentMaxWidth: "900px",
    },
    dialog: {
      contentPadding: "24px",
      widthXs: "400px",
      widthSm: "600px",
      widthMd: "900px",
      widthLg: "1200px",
      widthXl: "1400px",
      widthMax: "1680px",
      fullscreenContentPadding: "20px",
      radius: "38px",
    },
    swipeableDrawer: {
      contentPadding: "20px",
    },
    drawer: {
      contentPadding: "20px",
      temporaryDrawerWidth: "600px",
      permamentDrawerWidth: "450px",
    },
    confirmDialog: {
      width: "300px",
    },
    code: {
      radius: "4px",
      fontSizeCalc: "0.95 * 0.95",
    },
    sidebar: {
      width: "280px",
      logoMaxWidth: "120px",
      logoMaxHeight: "32px",
    },
    mobileAppHeader: {
      controlsHeight: "44px",
    },
    surface: {
      radiusSheetMediumDetent: "48px",
      radiusSheet: "38px",
      radiusControls: "9999px",
    },
    toggleButtonGroup: {
      gap: "8px",
    },
    tabBar: {
      sizeLarge: "54px",
      sizeMedium: "48px",
      sizeSmall: "32px",
      height: "62px",
    },
    prompt: {
      width: "400px",
    },
    checkbox: {
      radius: "8px",
    },
    treeView: {
      width: "280px",
      logoMaxWidth: "120px",
      logoMaxHeight: "32px",
      list: {
        gap: "4px",
      },
      item: {
        leadingMinWidth: "24px",
        nestedIndent: "8px",
        minHeight: "40px",
        paddingHorizontal: "8px",
        paddingVertical: "6px",
        radius: "20px",
        spaceBetween: "8px",
        trailingMinWidth: "28px",
      },
    },
  },
  typography: {
    fontFamily: {
      text: "Roboto Flex",
      code: "Inconsolata",
      icon: "Font Awesome 7 Pro",
      display: "Barlow",
    },
    fontWeight: {
      light: "light",
      regular: "regular",
      semibold: "semibold",
      text: "light",
      textBold: "semibold",
      button: "semibold",
      headingBold: "semibold",
      heading: "regular",
    },
    lineHeight: {
      1: "16px",
      2: "20px",
      3: "24px",
      4: "26px",
      5: "28px",
      6: "30px",
      7: "34px",
      8: "40px",
      9: "60px",
      "1p5": "18px",
      "2p5": "22px",
      "3p5": "25px",
      "0p5": "12px",
      "0p75": "14px",
      "5p5": "29px",
    },
    letterSpacing: {
      1: "0.04px",
      2: "0px",
      3: "0px",
      4: "-0.04px",
      5: "-0.08px",
      6: "-0.1px",
      7: "-0.12px",
      8: "-0.16px",
      9: "-0.4px",
      "1p5": "0.02px",
      "2p5": "0px",
      "3p5": "-0.02px",
      "0p5": "0.04px",
      display: "-0.8px",
      "0p75": "0.04px",
      "5p5": "-0.09px",
    },
    fontSize: {
      1: "12px",
      2: "14px",
      3: "16px",
      4: "18px",
      5: "20px",
      6: "24px",
      7: "28px",
      8: "34px",
      9: "60px",
      "1p5": "13px",
      "2p5": "15px",
      "3p5": "17px",
      "0p5": "10px",
      display: "120px",
      "0p75": "11px",
      "5p5": "22px",
    },
  },
  color: {
    red: {
      light: {
        1: "#fffcfc",
        2: "#fff7f6",
        3: "#ffebe8",
        4: "#ffdad5",
        5: "#ffcbc5",
        6: "#ffbbb4",
        7: "#fba69e",
        8: "#f38a82",
        9: "#e3242e",
        10: "#d4001d",
        11: "#d70e23",
        12: "#691013",
        a10: "#d4001d",
        a9: "#de000cdb",
        a7: "#f5160061",
        a11: "#d50016f2",
        a1: "#ff000003",
        surface: "#fff5f4cc",
        contrast: "#ffffff",
        a12: "#5f0003f0",
        a8: "#e711007d",
        a4: "#ff1f0029",
        a5: "#ff1b003b",
        a6: "#ff18014a",
        a3: "#ff220017",
        a2: "#ff1d000a",
      },
      dark: {
        1: "#100807",
        2: "#1f1110",
        3: "#3d0f0e",
        4: "#54060a",
        5: "#660d11",
        6: "#781c1c",
        7: "#922d2b",
        8: "#bd3c39",
        9: "#e3242e",
        10: "#be3d3a",
        11: "#ff8f86",
        12: "#ffd0cb",
        a12: "#ffd0cb",
        a4: "#ff00084f",
        a3: "#ff221936",
        a2: "#fd584317",
        a8: "#ff4e4aba",
        a10: "#ff4f4bbd",
        a9: "#ff2833e3",
        a11: "#ff8f86",
        a7: "#fe49448f",
        a6: "#fd323173",
        a1: "#e9000008",
        surface: "#35181580",
        a5: "#fd121b61",
        contrast: "#ffffff",
      },
    },
    green: {
      light: {
        1: "#fafffc",
        2: "#f2fcf7",
        3: "#e1f8ec",
        4: "#cef4e0",
        5: "#b7edd2",
        6: "#9ae3c0",
        7: "#71d4a8",
        8: "#00c086",
        9: "#05c288",
        10: "#00b67d",
        11: "#008353",
        12: "#093e2a",
        surface: "#effbf5cc",
        a11: "#008353",
        a10: "#00b67d",
        a9: "#00c186fa",
        a7: "#00b2638f",
        a6: "#00b96066",
        a4: "#00c65e30",
        a2: "#00c5630d",
        a1: "#00ff6605",
        contrast: "#ffffff",
        a5: "#00c06047",
        a3: "#00c45e1f",
        a8: "#00c086",
        a12: "#003722f5",
      },
      dark: {
        1: "#050c08",
        2: "#101a15",
        3: "#112c20",
        4: "#0b3b29",
        5: "#0f4a33",
        6: "#15593f",
        7: "#1a6a4b",
        8: "#1b7d59",
        9: "#05c288",
        10: "#00b67d",
        11: "#35d59a",
        12: "#a9f3cf",
        a12: "#b1ffd8f2",
        a11: "#3dfeb7d4",
        a4: "#13ffa133",
        a10: "#00feadb5",
        a5: "#20fea442",
        a3: "#42fba024",
        a6: "#2efdab54",
        a8: "#2fffb178",
        a9: "#04ffb1bf",
        a7: "#35ffae63",
        a2: "#72faa112",
        a1: "#00b40003",
        contrast: "#ffffff",
        surface: "#172a1f80",
      },
    },
    yellow: {
      dark: {
        1: "#0e0906",
        2: "#1d140f",
        3: "#321d0f",
        4: "#462001",
        5: "#542906",
        6: "#633716",
        7: "#7a4824",
        8: "#9d5d2e",
        9: "#e87700",
        10: "#db6b00",
        11: "#ffa25b",
        12: "#ffdfc9",
        a12: "#ffdfc9",
        a11: "#ffa25b",
        a10: "#ff7c00d9",
        a9: "#fe8200e8",
        a8: "#fe944599",
        a6: "#fd85295e",
        a5: "#ff70004f",
        a4: "#fd620040",
        a3: "#fd7b232b",
        a2: "#fc843c14",
        a1: "#de000005",
        surface: "#311e1380",
        a7: "#fd904175",
        contrast: "#ffffff",
      },
      light: {
        1: "#fefcfb",
        2: "#fff6f0",
        3: "#ffecdd",
        4: "#ffd9b7",
        5: "#ffcba0",
        6: "#ffbf92",
        7: "#f3ae80",
        8: "#e69761",
        9: "#e87700",
        10: "#dc6a00",
        11: "#c65b00",
        12: "#533119",
        a10: "#dc6a00",
        a3: "#ff710021",
        a9: "#e87700",
        surface: "#fff4eccc",
        a5: "#ff74005e",
        a12: "#401b00e6",
        contrast: "#ffffff",
        a2: "#ff66000f",
        a7: "#e75d0080",
        a4: "#ff790047",
        a1: "#c0400005",
        a6: "#ff6a006e",
        a11: "#c65b00",
        a8: "#d757009e",
      },
    },
    black: {
      a8: "#00000099",
      a5: "#0000004d",
      a4: "#00000033",
      a3: "#00000026",
      a1: "#0000000d",
      a9: "#000000b3",
      a7: "#00000080",
      a12: "#000000f2",
      a2: "#0000001a",
      a11: "#000000e6",
      a6: "#00000066",
      a10: "#000000cc",
    },
    white: {
      a12: "#fffffff2",
      a11: "#ffffffe6",
      a10: "#ffffffcc",
      a9: "#ffffffb3",
      a7: "#ffffff80",
      a3: "#ffffff26",
      a4: "#ffffff33",
      a1: "#ffffff0d",
      a8: "#ffffff99",
      a2: "#ffffff1a",
      a5: "#ffffff4d",
      a6: "#ffffff66",
    },
  },
  breakpoint: {
    "2xl": "1640px",
    xl: "1280px",
    sm: "520px",
    lg: "1024px",
    md: "768px",
    xs: "0px",
  },
  radius: {
    0: "0px",
    1: "8px",
    2: "16px",
    3: "24px",
    4: "32px",
    5: "40px",
    6: "48px",
    7: "56px",
    8: "64px",
    "1p5": "12px",
    "0p25": "2px",
    "0p75": "6px",
    "3p5": "28px",
    "1p25": "10px",
    "0p5": "4px",
    "2p25": "18px",
    "1p75": "14px",
    "2p5": "20px",
    "4p5": "36px",
    "5p5": "44px",
    full: "9999px",
    factor: "8px",
    "4p75": "38px",
    "2p75": "22px",
    "3p25": "26px",
    "3p75": "30px",
    "4p25": "34px",
    "5p25": "42px",
    "5p75": "46px",
    "6p25": "50px",
    "6p5": "52px",
    "6p75": "54px",
    "7p25": "58px",
    "7p5": "60px",
    "7p75": "62px",
    "0p875": "7px",
    "1p875": "15px",
    "1p125": "9px",
    "0p125": "1px",
    "0p375": "3px",
    "0p625": "5px",
    "1p375": "11px",
  },
  theme: {
    color: {
      backgroundDark: "#090a0b",
      backgroundLight: "#ffffff",
      grayDark: "#a0a0a8",
      grayLight: "#a0a0a8",
      accentDark: "#038bed",
      accentLight: "#038bed",
      successLight: "#05c288",
      successDark: "#05c288",
      dangerLight: "#e3242e",
      dangerDark: "#e3242e",
      warningLight: "#e87700",
      warningDark: "#e87700",
      infoLight: "#a0a0a8",
      infoDark: "#a0a0a8",
    },
  },
  responsive: {
    breakpoint: "xl",
    page: {
      header: {
        paddingTop: "20px",
        paddingBottom: "0px",
      },
      main: {
        paddingTop: "0px",
        paddingBottom: "80px",
      },
      container: {
        padding: "72px",
        gap: "32px",
      },
    },
  },
  effect: {
    blurRadius: {
      10: "10px",
      20: "20px",
      30: "30px",
      40: "40px",
      50: "50px",
      60: "60px",
      70: "70px",
      80: "80px",
      90: "90px",
      100: "100px",
      scrollEdgeEffectSoft: "10px",
      scrollEdgeEffectBase: "60px",
      uiBlurEffect: "30px",
    },
  },
  buttonShape: {
    radiusLarge: "9999px",
    radiusMedium: "9999px",
    radiusSmall: "9999px",
    radiusXsmall: "9999px",
  },
  typographyStyles: {
    h1: {
      fontFamily: "Barlow",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "60px",
      lineHeight: "60px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    h2: {
      fontFamily: "Barlow",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "34px",
      lineHeight: "40px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    h3: {
      fontFamily: "Barlow",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "28px",
      lineHeight: "34px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    h4: {
      fontFamily: "Barlow",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "24px",
      lineHeight: "30px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    h5: {
      fontFamily: "Barlow",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "20px",
      lineHeight: "28px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    h6: {
      fontFamily: "Barlow",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "18px",
      lineHeight: "26px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    subtitle1: {
      fontFamily: "Barlow",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    subtitle2: {
      fontFamily: "Barlow",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    bodyXlarge: {
      fontFamily: "Roboto Flex",
      fontWeight: 300,
      fontStyle: "normal",
      fontSize: "20px",
      lineHeight: "28px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    bodyXlargeStrong: {
      fontFamily: "Roboto Flex",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "20px",
      lineHeight: "28px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    bodyLarge: {
      fontFamily: "Roboto Flex",
      fontWeight: 300,
      fontStyle: "normal",
      fontSize: "18px",
      lineHeight: "26px",
      letterSpacing: "-0.04px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    bodyLargeStrong: {
      fontFamily: "Roboto Flex",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "18px",
      lineHeight: "26px",
      letterSpacing: "-0.04px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    bodyXLarge: {
      fontFamily: "Roboto Flex",
      fontWeight: 300,
      fontStyle: "normal",
      fontSize: "20px",
      lineHeight: "28px",
      letterSpacing: "-0.08px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    bodyXLargeStrong: {
      fontFamily: "Roboto Flex",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "20px",
      lineHeight: "28px",
      letterSpacing: "-0.08px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    body1: {
      fontFamily: "Roboto Flex",
      fontWeight: 300,
      fontStyle: "normal",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    body1Strong: {
      fontFamily: "Roboto Flex",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    body2: {
      fontFamily: "Roboto Flex",
      fontWeight: 300,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    body2Strong: {
      fontFamily: "Roboto Flex",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    code1: {
      fontFamily: "Inconsolata",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "14.4399995803833px",
      lineHeight: "18px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    code2: {
      fontFamily: "Inconsolata",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "12.635000228881836px",
      lineHeight: "16px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    caption: {
      fontFamily: "Roboto Flex",
      fontWeight: 300,
      fontStyle: "normal",
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    captionStrong: {
      fontFamily: "Roboto Flex",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.04px",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    overline: {
      fontFamily: "Barlow",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "12px",
      lineHeight: "30px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "UPPER",
    },
    button: {
      fontFamily: "Barlow",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "19px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    numberLarge: {
      fontFamily: "Roboto Flex",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "18px",
      lineHeight: "26px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    numberMedium: {
      fontFamily: "Roboto Flex",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    numberSmall: {
      fontFamily: "Roboto Flex",
      fontWeight: 600,
      fontStyle: "normal",
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0%",
      paragraphSpacing: "0",
      paragraphIndent: "0",
      textDecoration: "NONE",
      textCase: "ORIGINAL",
    },
    chip: {
      smallLabel: {
        fontFamily: "Roboto Flex",
        fontWeight: 600,
        fontStyle: "normal",
        fontSize: "12px",
        lineHeight: "15px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      mediumLabel: {
        fontFamily: "Roboto Flex",
        fontWeight: 600,
        fontStyle: "normal",
        fontSize: "13px",
        lineHeight: "17px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      largeLabel: {
        fontFamily: "Roboto Flex",
        fontWeight: 600,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "19px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    field: {
      label: {
        fontFamily: "Barlow",
        fontWeight: 600,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      value: {
        fontFamily: "Roboto Flex",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "15px",
        lineHeight: "22px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    list: {
      subheader: {
        fontFamily: "Barlow",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      label: {
        fontFamily: "Roboto Flex",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      labelStrong: {
        fontFamily: "Roboto Flex",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      secondary: {
        fontFamily: "Roboto Flex",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    menu: {
      subheader: {
        fontFamily: "Barlow",
        fontWeight: 600,
        fontStyle: "normal",
        fontSize: "13px",
        lineHeight: "18px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      label: {
        fontFamily: "Roboto Flex",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "15px",
        lineHeight: "22px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      labelStrong: {
        fontFamily: "Roboto Flex",
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "15px",
        lineHeight: "22px",
        letterSpacing: "0px",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      secondary: {
        fontFamily: "Roboto Flex",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "13px",
        lineHeight: "18px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      quickActionLabel: {
        fontFamily: "Roboto Flex",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "13px",
        lineHeight: "16px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    tabBar: {
      stackedLabel: {
        fontFamily: "Barlow",
        fontWeight: 600,
        fontStyle: "normal",
        fontSize: "10px",
        lineHeight: "12px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      label: {
        fontFamily: "Barlow",
        fontWeight: 600,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
    title: {
      title2Line: {
        fontFamily: "Barlow",
        fontWeight: 600,
        fontStyle: "normal",
        fontSize: "15px",
        lineHeight: "18px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      title: {
        fontFamily: "Barlow",
        fontWeight: 600,
        fontStyle: "normal",
        fontSize: "17px",
        lineHeight: "22px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      titleLarge: {
        fontFamily: "Barlow",
        fontWeight: 600,
        fontStyle: "normal",
        fontSize: "28px",
        lineHeight: "34px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      titleLargeCompact: {
        fontFamily: "Barlow",
        fontWeight: 600,
        fontStyle: "normal",
        fontSize: "20px",
        lineHeight: "28px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      subtitle: {
        fontFamily: "Barlow",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "12px",
        lineHeight: "14px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
      subtitleLarge: {
        fontFamily: "Barlow",
        fontWeight: 300,
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0%",
        paragraphSpacing: "0",
        paragraphIndent: "0",
        textDecoration: "NONE",
        textCase: "ORIGINAL",
      },
    },
  },
  gridStyles: {
    breakpoint: {
      xs: {
        columnCount: 12,
        columnGap: "16px",
      },
      sm: {
        columnCount: 12,
        columnGap: "24px",
      },
      md: {
        columnCount: 12,
        columnGap: "24px",
      },
      lg: {
        columnCount: 12,
        columnGap: "24px",
      },
      xl: {
        columnCount: 12,
        columnGap: "32px",
      },
      max: {
        columnCount: 12,
        columnGap: "32px",
      },
    },
  },
  effectStyles: {
    uiBlurEffect: {
      role: "background",
      blur: "30px",
    },
    glassShadow: [
      {
        inset: false,
        color: "#0000001f",
        offsetX: "0px",
        offsetY: "5px",
        blur: "40px",
        spread: "1px",
      },
    ],
    filterChipShadow: [
      {
        inset: false,
        color: {
          light: "#ffffff1f",
          dark: "#0000001f",
        },
        offsetX: "0px",
        offsetY: "5px",
        blur: "40px",
        spread: "0px",
      },
    ],
    elevation: {
      1: [
        {
          inset: false,
          color: {
            light: "#0000000a",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "1px",
          blur: "5px",
          spread: "1px",
        },
      ],
      2: [
        {
          inset: false,
          color: {
            light: "#0000000f",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "2px",
          blur: "8px",
          spread: "1px",
        },
      ],
      3: [
        {
          inset: false,
          color: {
            light: "#0000000f",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "3px",
          blur: "10px",
          spread: "1px",
        },
      ],
      4: [
        {
          inset: false,
          color: {
            light: "#00000012",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "4px",
          blur: "12.5px",
          spread: "1px",
        },
      ],
      5: [
        {
          inset: false,
          color: {
            light: "#00000014",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "5px",
          blur: "15px",
          spread: "1px",
        },
      ],
      6: [
        {
          inset: false,
          color: {
            light: "#00000017",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "6px",
          blur: "17.5px",
          spread: "1px",
        },
      ],
      7: [
        {
          inset: false,
          color: {
            light: "#00000017",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "7px",
          blur: "20px",
          spread: "1px",
        },
      ],
      8: [
        {
          inset: false,
          color: {
            light: "#0000001a",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "8px",
          blur: "22.5px",
          spread: "1px",
        },
      ],
      9: [
        {
          inset: false,
          color: {
            light: "#0000001c",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "9px",
          blur: "25px",
          spread: "1px",
        },
      ],
      10: [
        {
          inset: false,
          color: {
            light: "#0000001f",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "10px",
          blur: "27.5px",
          spread: "1px",
        },
      ],
      11: [
        {
          inset: false,
          color: {
            light: "#0000001f",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "11px",
          blur: "30px",
          spread: "1px",
        },
      ],
      12: [
        {
          inset: false,
          color: {
            light: "#00000021",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "12px",
          blur: "32.5px",
          spread: "1px",
        },
      ],
      13: [
        {
          inset: false,
          color: {
            light: "#00000024",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "13px",
          blur: "35px",
          spread: "1px",
        },
      ],
      14: [
        {
          inset: false,
          color: {
            light: "#00000026",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "14px",
          blur: "37.5px",
          spread: "1px",
        },
      ],
      15: [
        {
          inset: false,
          color: {
            light: "#00000026",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "15px",
          blur: "40px",
          spread: "1px",
        },
      ],
      16: [
        {
          inset: false,
          color: {
            light: "#00000029",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "16px",
          blur: "42.5px",
          spread: "1px",
        },
      ],
      17: [
        {
          inset: false,
          color: {
            light: "#0000002b",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "17px",
          blur: "45px",
          spread: "1px",
        },
      ],
      18: [
        {
          inset: false,
          color: {
            light: "#0000002e",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "18px",
          blur: "47.5px",
          spread: "1px",
        },
      ],
      19: [
        {
          inset: false,
          color: {
            light: "#0000002e",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "19px",
          blur: "50px",
          spread: "1px",
        },
      ],
      20: [
        {
          inset: false,
          color: {
            light: "#00000030",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "20px",
          blur: "52.5px",
          spread: "1px",
        },
      ],
      21: [
        {
          inset: false,
          color: {
            light: "#00000033",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "21px",
          blur: "55px",
          spread: "1px",
        },
      ],
      22: [
        {
          inset: false,
          color: {
            light: "#00000036",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "22px",
          blur: "57.5px",
          spread: "1px",
        },
      ],
      23: [
        {
          inset: false,
          color: {
            light: "#00000036",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "23px",
          blur: "60px",
          spread: "1px",
        },
      ],
      24: [
        {
          inset: false,
          color: {
            light: "#00000038",
            dark: {
              light: "#ffffff00",
              dark: "#00000000",
            },
          },
          offsetX: "0px",
          offsetY: "24px",
          blur: "62.5px",
          spread: "1px",
        },
      ],
    },
  },
  colorStyles: {
    controlBorderOutlined: {
      primary: [
        {
          color: {
            light: "#0075d5",
            dark: "#75baff",
          },
          position: 0,
        },
        {
          color: {
            light: "#0075d5",
            dark: "#75baff",
          },
          position: 1,
        },
      ],
      secondary: [
        {
          color: {
            light: "#00000a9c",
            dark: "#f3f3ffb8",
          },
          position: 0,
        },
        {
          color: {
            light: "#00000a9c",
            dark: "#f3f3ffb8",
          },
          position: 1,
        },
      ],
      error: [
        {
          color: {
            light: "#d50016f2",
            dark: "#ff8f86",
          },
          position: 0,
        },
        {
          color: {
            light: "#d50016f2",
            dark: "#ff8f86",
          },
          position: 1,
        },
      ],
      warning: [
        {
          color: {
            light: "#c65b00",
            dark: "#ffa25b",
          },
          position: 0,
        },
        {
          color: {
            light: "#c65b00",
            dark: "#ffa25b",
          },
          position: 1,
        },
      ],
      success: [
        {
          color: {
            light: "#008353",
            dark: "#3dfeb7d4",
          },
          position: 0,
        },
        {
          color: {
            light: "#008353",
            dark: "#3dfeb7d4",
          },
          position: 1,
        },
      ],
      info: [
        {
          color: {
            light: "#00000a9c",
            dark: "#f3f3ffb8",
          },
          position: 0,
        },
        {
          color: {
            light: "#00000a9c",
            dark: "#f3f3ffb8",
          },
          position: 1,
        },
      ],
    },
    effect: {
      specularBorder: [
        {
          color: "#ffffffe6",
          position: 0,
        },
        {
          color: "#ffffff59",
          position: 0.10000000149011612,
        },
        {
          color: "#ffffff26",
          position: 0.5,
        },
        {
          color: "#ffffff59",
          position: 0.8999999761581421,
        },
        {
          color: "#ffffffe6",
          position: 1,
        },
      ],
      specularBorderStrong: [
        {
          color: "#ffffffe6",
          position: 0,
        },
        {
          color: "#ffffffd9",
          position: 0.10000000149011612,
        },
        {
          color: "#ffffff80",
          position: 0.5,
        },
        {
          color: "#ffffffd9",
          position: 0.8999999761581421,
        },
        {
          color: "#ffffffe6",
          position: 1,
        },
      ],
      ripple: [
        {
          color: "#ffffff1a",
          position: 0,
        },
        {
          color: "#ffffff00",
          position: 1,
        },
      ],
    },
    containedIcon: {
      primary: [
        {
          color: {
            light: "#038bed",
            dark: "#038bed",
          },
          position: 0,
        },
        {
          color: {
            light: "#038bed",
            dark: "#038bed",
          },
          position: 1,
        },
      ],
      secondary: [
        {
          color: {
            light: "#8d8d95",
            dark: "#6c6c77",
          },
          position: 0,
        },
        {
          color: {
            light: "#8d8d95",
            dark: "#6c6c77",
          },
          position: 1,
        },
      ],
      success: [
        {
          color: {
            light: "#05c288",
            dark: "#05c288",
          },
          position: 0,
        },
        {
          color: {
            light: "#05c288",
            dark: "#05c288",
          },
          position: 1,
        },
      ],
      error: [
        {
          color: {
            light: "#e3242e",
            dark: "#e3242e",
          },
          position: 0,
        },
        {
          color: {
            light: "#e3242e",
            dark: "#e3242e",
          },
          position: 1,
        },
      ],
      warning: [
        {
          color: {
            light: "#e87700",
            dark: "#e87700",
          },
          position: 0,
        },
        {
          color: {
            light: "#e87700",
            dark: "#e87700",
          },
          position: 1,
        },
      ],
      info: [
        {
          color: {
            light: "#8d8d95",
            dark: "#6c6c77",
          },
          position: 0,
        },
        {
          color: {
            light: "#8d8d95",
            dark: "#6c6c77",
          },
          position: 1,
        },
      ],
    },
    material: {
      light: {
        ultrathin: "#f6f6f65c",
        thin: "#f6f6f67a",
        regular: "#f6f6f699",
        thick: "#f6f6f6c2",
        ultrathick: "#f6f6f6d6",
        accessory: "#e1e1e180",
      },
      dark: {
        ultrathin: "#1212121a",
        thin: "#12121233",
        regular: "#1212124d",
        thick: "#12121266",
        ultrathick: "#12121280",
        accessory: "#33333380",
      },
    },
    vibrant: {
      divider: {
        light: "#e6e6e6",
        dark: "#1a1a1a",
      },
      fill: {
        light: {
          prominent: "#1e2022",
          primary: "#cccccc",
          secondary: "#e0e0e0",
          tertiary: "#ededed",
          quaternary: "#f3f3f3",
        },
        dark: {
          prominent: "#e0e0e0",
          primary: "#333333",
          secondary: "#1f1f1f",
          tertiary: "#121212",
          quaternary: "#0c0c0c",
        },
      },
      text: {
        light: {
          primary: "#333333",
          secondary: "#999999",
          tertiary: "#bfbfbf",
          disabled: "#d9d9d9",
        },
        dark: {
          primary: "#fffffff5",
          secondary: "#999999",
          tertiary: "#404040",
          disabled: "#262626",
        },
      },
      control: {
        light: {
          glassProminent: "#ffffff",
          prominent: "#ffffff",
          primary: "#404040",
          secondary: "#8c8c8c",
          disabled: "#d9d9d9",
        },
        dark: {
          glassProminent: "#bfbfbf",
          prominent: "#333333",
          primary: "#bfbfbf",
          secondary: "#737373",
          disabled: "#262626",
        },
      },
    },
  },
};
